<template>
  <div class="h-100">
    <vue-snotify />
    <Navbar />
    <div
      id="app"
      class="py-5 position-relative"
      style="min-height: calc(100% - 148px);"
    >
      <RouterView />
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
  created() {
    // check jwtToken is saved before
    const jwtToken = localStorage.getItem('jwtToken');
    // check user region is saved before, or there is a region data in query parameters
    const region = localStorage.getItem('region') || this.$route.query.region;
    // check user country is saved before, or there is a country data in query parameters
    const country = localStorage.getItem('country') || this.$route.query.country;
    // check user gender is saved before, or there is a gender data in query parameters
    const gender = localStorage.getItem('gender') || this.$route.query.gender;

    // if user has token, save it to vuex
    if (jwtToken) this.setJwtToken(jwtToken);
    // if user has region, save it to vuex
    if (region) this.setRegion(region);
    // if user has country, save it to vuex
    if (country) this.setCountry(country);
    // if user has gender, save it to vuex
    if (gender) this.setGender(gender);
  },
  methods: {
    ...mapMutations([
      'setJwtToken',
      'setRegion',
      'setCountry',
      'setGender',
    ]),
  },
};
</script>

<style>
html, body {
  height: 100%;
}
</style>
